import React from "react";
import { useReducers } from "../../shared/hooks/useReducer";

import MoreInformationModal from "./MoreInformationModal";
import constants from "../../shared/constants";

const { REDUCER_TYPE } = constants;

const Index = (props) => {
  const { featureToggles } = useReducers(REDUCER_TYPE.APP);
  const { is4KVodEnabled } = featureToggles;

  return <MoreInformationModal is4KVodEnabled={is4KVodEnabled} {...props} />;
};

export default Index;
